export default __webpack_public_path__ + "static/media/reference.29382015.pdf";